
export class PageLoadHook {
  get name() {
    return this.constructor.name;
  }

  onPageLoad() {
    throw Error("onPageLoad() is not implemented.");
  }
}
